import Rellax from 'rellax';

// eslint-disable-next-line import/no-mutable-exports
let rellax = null;

export default rellax;

export function init() {
    if (document.getElementsByClassName('js-rellax').length > 0) { rellax = new Rellax('.js-rellax'); }
}
